module.exports = __webpack_public_path__ + "static/media/synchronize-arrows-1.3cc215ee.svg";